/**
 * fileShare.js — отдать пользователю готовый файл (PDF отчёта, инвойса и т.п.).
 *
 * ⚠️ Почему на iOS нельзя просто `<a download>`:
 * WebKit атрибут download игнорирует. Клик по ссылке на blob: открывает файл
 * как предпросмотр, и адресная строка страницы становится blob:-ссылкой. Дальше
 * юзер жмёт «…» → Share → WhatsApp, и системный шер прикладывает к файлу ещё и
 * URL страницы — то есть blob:https://…/437bcfe6-… Ссылка мусорная (живёт только
 * в его вкладке) и уезжает адресату вместе с документом.
 *
 * Правильный путь на iOS — Web Share API с файлом: navigator.share({ files }).
 * Строго без url/text/title: любое из этих полей система добавит в сообщение.
 *
 * ⚠️ Второй подводный камень — user activation. navigator.share обязан быть
 * вызван из свежего жеста. Мы файл сначала качаем с бэка, и к моменту, когда
 * промис зарезолвится, активация уже протухла → NotAllowedError. Поэтому флоу
 * двухшаговый: сначала скачали и запомнили File, потом отдельным тапом шарим.
 * Тот же приём в CustomReportButton (отчёт по работе).
 */

/** iOS/iPadOS. iPadOS 13+ представляется как Macintosh, отличаем по тач-поинтам. */
export function isIosLike() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iphone|ipad|ipod/i.test(ua)) return true;
  return /Macintosh/.test(ua) && (navigator.maxTouchPoints || 0) > 1;
}

/** Умеет ли система принять этот файл в нативный «Поделиться». */
export function canShareFile(file) {
  try {
    return !!(navigator.canShare && navigator.canShare({ files: [file] }));
  } catch {
    return false;
  }
}

/**
 * Нативный шер одним файлом. Возвращает 'shared' | 'cancelled' | 'failed'.
 * Отмену пользователем (AbortError) ошибкой не считаем.
 */
export async function shareFile(file) {
  try {
    await navigator.share({ files: [file] });   // без url/text/title — см. шапку
    return 'shared';
  } catch (e) {
    return e?.name === 'AbortError' ? 'cancelled' : 'failed';
  }
}

/** Обычное скачивание (десктоп, Android). На iOS не использовать — см. шапку. */
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
